var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"GfFundraisingPageSummary"}},[_c('div',[_c('ActivityDigestSummary',{key:_vm.renderKey,attrs:{"digest-summary":_vm.summary,"component-settings":_vm.componentSettings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }